import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Titled card frame for dashboard widgets, with an optional "view all" link.
 * @param {{ title: string, description?: string, action?: { label: string, to: string },
 *           className?: string, children: React.ReactNode }} props
 */
function DashboardPanel({ title, description, action, className = "", children }) {
  return (
    <section
      aria-label={title}
      className={`flex h-full flex-col rounded-xl border border-app-primary bg-app-card p-5 shadow-sm ${className}`}
    >
      <header className="mb-4 flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-app-heading">
            {title}
          </h3>
          {description && <p className="mt-1 text-xs text-app-muted">{description}</p>}
        </div>
        {action && (
          <Link
            to={action.to}
            className="group inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:text-blue-700 dark:text-sky-400 dark:hover:text-sky-300"
          >
            {action.label}
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
        )}
      </header>
      <div className="min-h-0 flex-1">{children}</div>
    </section>
  );
}

export default DashboardPanel;
